import React, { useState } from "react";
import Select, { TOption } from "../../../Components/Select";
import LogActionForm from "./LogActionForm";
import NotifyActionForm from "./NotifyActionForm";
import MqttActionForm from "./MqttActionForm";
import { getControlsWithCommands } from "../utils";
import { IControl } from "../../controls/types";
import {
  defaultLogAction,
  TLogAction,
  defaultNotifyAction,
  TNotifyAction,
  defaultMqttAction,
  TMqttAction,
} from "./types";
import { useTranslation } from "react-i18next";

const defaultActions = {
  log: defaultLogAction,
  notify: defaultNotifyAction,
  mqtt: defaultMqttAction,
};

type TActionType = "log" | "notify" | "mqtt";

export type TAction = TLogAction | TNotifyAction | TMqttAction;

interface IActionFormProps {
  action: TAction;
  controls: IControl[];
  onChange: (action: TAction) => void;
}

const ActionForm = (props: IActionFormProps) => {
  const { action, controls, onChange } = props;
  const [initialAction, setInitialAction] = useState<TAction>(action);
  const { t } = useTranslation();

  const actionTypeOptions: TOption<TActionType>[] = [
    { value: "log", label: t("Log") },
    { value: "notify", label: t("Notify") },
    { value: "mqtt", label: t("MQTT") },
  ];

  return (
    <>
      <Select
        fullWidth
        label={t("Action Type")}
        options={actionTypeOptions}
        value={initialAction.type}
        onChange={(event) => {
          const newAction = defaultActions[event.target.value as TActionType];
          setInitialAction(newAction);
          onChange(newAction);
        }}
        data-cy="action-select-action-type"
      />
      {initialAction.type === "log" && (
        <LogActionForm action={initialAction} onChange={onChange} />
      )}
      {initialAction.type === "notify" && (
        <NotifyActionForm action={initialAction} onChange={onChange} />
      )}
      {initialAction.type === "mqtt" && (
        <MqttActionForm
          action={initialAction}
          controls={getControlsWithCommands(controls)}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default ActionForm;
